import { AuthTrustFooter } from '../Auth/AuthTrustFooter'

/**
 * Selo de confiança do Hub público da receita (/prescricao e /assinatura).
 * Reaproveita EXATAMENTE o footer de confiança da tela de login
 * (AuthTrustFooter) — mesma estrutura, mensagem (escudo + LGPD) e links
 * (Política de Privacidade · Termos de Uso). Mensagem genérica por design:
 * NÃO referencia token, código de desbloqueio nem dados do paciente.
 */
export const RodapeConfiancaReceita = () => <AuthTrustFooter />
